export default function modal() {
  $('.js-modal-toggle').on('click', function (event, options) {
    options = options || {};

    if (options.continue) {
      return true;
    }

    var modal = $('.js-modal').clone().insertAfter('.js-modal');

    modal.find('.js-modal-title').empty();
    modal.find('.js-modal-text').empty();
    modal.find('.js-modal-cancel').empty();
    modal.find('.js-modal-confirm').empty();

    event.preventDefault();

    var target = $(event.target).closest('.js-modal-toggle');

    modal.find('.js-modal-title').text(target.data('title'));
    modal.find('.js-modal-text').text(target.data('text'));
    modal.find('.js-modal-cancel').text(target.data('cancel'));
    modal.find('.js-modal-confirm').text(target.data('confirm'));

    modal.show();

    modal.find('.js-modal-confirm').on('click', function () {
      if (target.is('a')) {
        window.location.href = target.prop('href');
      } else if (target.is('button')) {
        target.trigger('click', { 'continue': true });
      }

      modal.hide().remove();
    });

    modal.find('.js-modal-cancel').on('click', function () {
      modal.hide().remove();
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/components/modal.js